import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyCs6() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`VI.`}
            <br />
            {`Podmínky poskytování služby`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Uživatel nesmí v rámci služby šířit informace, jejichž obsah je v rozporu s dobrými mravy či s obecně závaznými právními předpisy.`}</li>
            <li>{`Uživatel nesmí v rámci služby používat mechanismy, nástroje, programové vybavení nebo postupy, které mají nebo by mohly mít negativní vliv na provoz služby. `}</li>
            <li>{`Uživatel nesmí vyvíjet činnost směřující k tomu, aby byl znemožněn nebo omezen provoz služby či serveru poskytovatele, na kterém je služba provozována, nebo provádět jiné útoky na tento server, ani nesmí být při takové činnosti nápomocen třetí osobě. Uživatel nesmí uživatelský účet a službu využívat způsobem, který by nepřiměřeně omezoval v užívání služby další zákazníky poskytovatele či jinak nepřiměřeně omezoval poskytovatele. `}</li>
            <li>{`Přístupové údaje ke službě jsou určeny pouze pro jednu fyzickou osobu, případně pro společnou domácnost v rámci rodinného předplatného, a jsou nepřenosné. Uživatel nemá právo poskytnout, postoupit, pronajímat, půjčovat ani jinak poskytovat třetím osobám oprávnění k přístupu ke službě, trvale či dočasně, úplatně či bezúplatně, a to bez předchozího písemného souhlasu poskytovatele. Uživatel není oprávněn sdílet přístupové údaje mezi více fyzickými osobami, a to ani tehdy, bude-li uživatelem právnická osoba, kdy v takovém případě je právnická osoba povinna určit jednu fyzickou osobu, která bude mít do služby přístup. V případě ztráty přístupových údajů nebo podezření na jejich zneužití či únik je uživatel povinen bezodkladně informovat poskytovatele. Poskytovatel neodpovídá za škodu, která by vznikla uživateli zneužitím přístupu do služby bez zavinění poskytovatele. V případě podezření na sdílení přístupu do služby je poskytovatel oprávněn do ověření této skutečnosti na nezbytnou dobu přerušit uživateli přístup do služby s tím, že nárok na úplatu za příslušné obdobní není tímto dotčen. `}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={5} className={sList}>
            <li>{`Uživatel (příp. jeho zákonný zástupce) prohlašuje, že služby bude využívat na vlastní odpovědnost a riziko s přihlédnutím ke svému aktuálnímu zdravotnímu stavu. Náročnost a intenzitu cvičení uživatel přizpůsobí svým schopnostem. Případné zdravotní omezení (nemoc, úraz, omezenou pohyblivost, těhotenství apod.) bude uživatel konzultovat se svým lékařem a dbát jeho doporučení. Poskytovatel nenese žádnou odpovědnost za případné zdravotní problémy uživatele během využití služby nebo po ní. V případě úrazu, poranění nebo zdravotní komplikace se uživatel vzdává jakýchkoliv nároků vůči poskytovateli. `}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyCs6;
